// Contrato explícito da classificação manual; nunca inferir do booleano legado.
export function lerTipoInstituicao(dados) {
  const valor = typeof dados === "string" ? dados : dados?.tipo_instituicao;
  return valor === "mantenedora" || valor === "escola" ? valor : "";
}

export function montarDadosTipoProcesso(processo, tipoInstituicao, editando = false) {
  const categoria = lerTipoInstituicao(tipoInstituicao);
  if (!categoria) throw new Error("Selecione Mantenedora ou Escola.");
  return {
    nome: processo.nome,
    descricao: processo.descricao,
    documentos: editando ? processo.documentos.map((id) => ({ id })) : [...processo.documentos],
    tipo_instituicao: categoria,
    ...(Array.isArray(processo.ordem_documentos) ? { ordem_documentos: [...processo.ordem_documentos] } : {}),
    ...(editando && typeof processo.versao_ordem === 'string' ? { versao_ordem: processo.versao_ordem } : {}),
  };
}
